import { reviewModalContentStyles } from '../ReviewModalContent.styles';

export const reviewSectionStyles = {
	sectionWrapper: {
		display: 'flex',
		flexDirection: 'column',
		gap: 1
	},

	sectionHeader: {
		display: 'grid',
		gridTemplateColumns: '0.75fr 1fr 1fr',
		gap: 2,
		alignItems: 'center'
	},

	sectionTitle: reviewModalContentStyles.sectionTitle,

	columnHeader: {
		fontSize: '0.875rem',
		fontWeight: 600
	},

	rowsContainer: {
		display: 'flex',
		flexDirection: 'column'
	}
};
